export const getYardBlockNameWithAssignedBays = ({
  name,
  assignedBays,
}: {
  id: string
  name: string
  assignedBays: string[]
}): string => {
  if (assignedBays.length === 0) return name

  const min = assignedBays[0]
  const max = assignedBays[assignedBays.length - 1]

  return `${name}.${min}${min !== max ? '-' + max : ''}`
}
